/**
 * API Constants for Office Arena
 * Centralized API endpoint definitions following REST conventions
 */

export const API_ENDPOINTS = {
  // Player endpoints
  PLAYERS: {
    LIST: '/players',
    CREATE: '/players',
    GET: '/players/:id',
    UPDATE: '/players/:id',
    DELETE: '/players/:id',
    ME: '/players/me', // Get current authenticated user's profile
  },

  // Match endpoints
  MATCHES: {
    LIST: '/matches',
    CREATE: '/matches',
    BATCH_CREATE: '/matches/batch',
    GET: '/matches/:id',
    UPDATE: '/matches/:id',
    VERIFY: '/matches/:id',
    DELETE: '/matches/:id',
  },

  // Bread tracking endpoints
  BREAD: {
    LIST: '/bread',
    CREATE: '/bread',
    GET: '/bread/:id',
    UPDATE: '/bread/:id',
    DELETE: '/bread/:id',
    DEBT: '/bread/debt',
  },

  // Chemistry neural network endpoints
  CHEMISTRY: {
    GET_WEIGHTS: '/chemistry',
    UPDATE_WEIGHTS: '/chemistry',
  },
};

// HTTP status codes for reference
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
};

// API response timeout configurations
export const API_TIMEOUTS = {
  DEFAULT: 10000, // 10 seconds
  LONG_RUNNING: 30000, // 30 seconds for complex operations
  SHORT: 5000, // 5 seconds for quick operations
};
